import { Fragment } from 'react';
import { useMovements } from './hooks/useMovements';
import { MovementControl } from './components/movements/MovementControl';
import { ToothInfoAndButtons } from './components/movements/ToothInfoAndButtons';
import { OcclusionMapAndContactButtons } from './components/movements/OcclusionMapAndContactButtons';
import { StepButtons } from './components/movements/StepButtons';
import {
    resetSelectedToothToInitialPosition,
    restoreSelectedToothToNextPosition,
    undoSelectedToothLastMovement,
} from "../../Domain/Mesh/Handler/MeshSelectorEvent";
import { computeAndDisplayTeethIntersection} from 'Domain/Scene/Handler/CollisionHandler';
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';

/*****************************************************************
 * Tooth Movements Side Panel
 * ***************************************************************/

export const Movements = () => {
    const {
        dispatch,
        isInterferenceEnabled,
        isStripingEnabled,
        movementValues,
        isStepEditMode,
        setIsStepEditMode,
        stepValues,
        setStepValues,
        viewModeSingle,
        panelStyle,
        currentTooth,
        selectedTooth,
        handleValueChange,
        selectedPointRotation,
        selectedPointTip,
        selectedPointTorque,
    } = useMovements();

    const isFreeMode = !isStepEditMode;
    const showSingleColumn = viewModeSingle;
    const showDoubleColumn = !viewModeSingle;

    const renderSingleColumn = () => (
        <>
            {isFreeMode ? (
                <>
                    <ToothInfoAndButtons
                        clickedTooth={currentTooth}
                        selectedTooth={selectedTooth}
                        resetSelectedToothToInitialPosition={resetSelectedToothToInitialPosition}
                        undoSelectedToothLastMovement={undoSelectedToothLastMovement}
                        restoreSelectedToothToNextPosition={restoreSelectedToothToNextPosition}
                        isStepEditMode={isStepEditMode}
                    />
                    <OcclusionMapAndContactButtons
                        isInterferenceEnabled={isInterferenceEnabled}
                        isStripingEnabled={isStripingEnabled}
                        isStepEditMode={isStepEditMode}
                        dispatch={dispatch}
                        computeAndDisplayTeethIntersection={computeAndDisplayTeethIntersection}
                    />
                    <hr className="horizontal-bar" />
                </>
            ) : (
                <div className="spacer"></div>
            )}

            {Object.keys(movementValues).map((movement, index) => (
                <Fragment key={movement}>
                    <MovementControl
                        movement={movement}
                        isStepEditMode={isStepEditMode}
                        stepValues={stepValues}
                        setStepValues={setStepValues}
                        movementValues={movementValues}
                        currentTooth={currentTooth}
                        handleValueChange={handleValueChange}
                        selectedPointRotation={selectedPointRotation}
                        selectedPointTip={selectedPointTip}
                        selectedPointTorque={selectedPointTorque}
                        viewModeSingle={viewModeSingle}
                    />
                    {index === 2 && <hr className="horizontal-bar" />}
                </Fragment>
            ))}
            <hr className="horizontal-bar" />

            <StepButtons
                isStepEditMode={isStepEditMode}
                setIsStepEditMode={setIsStepEditMode}
                stepValues={stepValues}
                setStepValues={setStepValues}
                locale={locale}
                ihm_viewer__dictionary={ihm_viewer__dictionary}
            />
        </>
    );

    const renderDoubleColumn = () => (
        <>
            {Object.keys(movementValues).map((movement, index) => (
                <Fragment key={movement}>
                    <MovementControl
                        movement={movement}
                        isStepEditMode={isStepEditMode}
                        stepValues={stepValues}
                        setStepValues={setStepValues}
                        movementValues={movementValues}
                        currentTooth={currentTooth}
                        handleValueChange={handleValueChange}
                        selectedPointRotation={selectedPointRotation}
                        selectedPointTip={selectedPointTip}
                        selectedPointTorque={selectedPointTorque}
                        viewModeSingle={viewModeSingle}
                    />
                    {index === 2 && (
                        <>
                            <hr className="vertical-bar" />
                            <div className="central-bottom-buttons">
                                {isFreeMode && (
                                    <>
                                        <ToothInfoAndButtons
                                            clickedTooth={currentTooth}
                                            selectedTooth={selectedTooth}
                                            resetSelectedToothToInitialPosition={resetSelectedToothToInitialPosition}
                                            undoSelectedToothLastMovement={undoSelectedToothLastMovement}
                                            restoreSelectedToothToNextPosition={restoreSelectedToothToNextPosition}
                                            isStepEditMode={isStepEditMode}
                                        />
                                        <OcclusionMapAndContactButtons
                                            isInterferenceEnabled={isInterferenceEnabled}
                                            isStripingEnabled={isStripingEnabled}
                                            isStepEditMode={isStepEditMode}
                                            dispatch={dispatch}
                                            computeAndDisplayTeethIntersection={computeAndDisplayTeethIntersection}
                                        />
                                    </>
                                )}
                                <StepButtons
                                    isStepEditMode={isStepEditMode}
                                    setIsStepEditMode={setIsStepEditMode}
                                    stepValues={stepValues}
                                    setStepValues={setStepValues}
                                    locale={locale}
                                    ihm_viewer__dictionary={ihm_viewer__dictionary}
                                />
                            </div>
                            <hr className="vertical-bar" />
                        </>
                    )}
                </Fragment>
            ))}
        </>
    );

    const hasGlassPanel = panelStyle === 'LeftPanel' || panelStyle === 'BottomPanel';

    return (
        <nav id={panelStyle}>
            {hasGlassPanel ? (
                <div className="glass-panel">
                    {showSingleColumn && renderSingleColumn()}
                    {showDoubleColumn && renderDoubleColumn()}
                </div>
            ) : (
                <>
                    {showSingleColumn && renderSingleColumn()}
                    {showDoubleColumn && renderDoubleColumn()}
                </>
            )}
        </nav>
    );
};
